'use strict';

var App = require('app');
var AppState = require('app_state');
var Misc = require('utils/misc');
var OOP = require('utils/oop');
var i18n = require('utils/i18n');

function createConfigDialogValue(data, deviceID) {
    var result = $.extend(true, {}, data);
    result.uniqueId = '' + deviceID + '_' + data.type + '_' + data.nr;
    return result;
}

function getConfigValueIDs(values) {
    return Misc.selectWhere(values, undefined, function (a) {
        return '' + a.device_id + '_' + a.type + '_' + a.nr;
    });
}

function getConfigDialogSelectedDevices(selectedValues) {
    var devices = Misc.selectWhere(selectedValues, undefined, function (k) {
        return parseInt(k.split('_')[0]);
    });

    return Misc.selectWhere(devices, function (d, idx) {
        return devices.indexOf(d) == idx;
    });
}

function getConfigDialogData(devices, deviceValues, selectedValues, selectedDevice, deviceName) {
    var allValues = [];
    // add all values from the selected device
    var selectedDeviceValues = Misc.selectWhere(deviceValues, function (di) {
        return di.id == selectedDevice;
    });

    selectedDeviceValues.forEach(function (di) {
        // var values = createConfigDialogValue(v, di.id)
        di.values.forEach(function (v) {
            allValues.push(createConfigDialogValue(v, di.id));
        });
    });

    var nonSelectedValues = Misc.selectWhere(deviceValues, function (di) {
        return di.id != selectedDevice;
    });

    nonSelectedValues.forEach(function (di) {
        Misc.selectWhere(
            Misc.selectWhere(di.values, undefined, function (vi) {
                return createConfigDialogValue(vi, di.id);
            }),
            function (item) {
                return selectedValues.includes(item.uniqueId);
            }
        ).forEach(function (item) {
            allValues.push(item);
        });
    });

    var deviceNames = {};
    devices.forEach(function (d) {
        deviceNames[d.id] = d.name;
    });

    var usedDevices = getConfigDialogSelectedDevices(selectedValues);
    if (!usedDevices.includes(selectedDevice) && selectedDevice != 0) {
        usedDevices.push(selectedDevice);
    }

    var allValueGroups = Misc.selectWhere(usedDevices, undefined, function (t) {
        return {
            name: deviceNames[t],
            values: Misc.selectWhere(allValues, function (v) {
                return v.uniqueId.startsWith('' + t + '_');
            }).sort(function (a, b) {
                return a.name.localeCompare(b.name);
            }),
        };
    }).sort(function (a, b) {
        return a.name.localeCompare(b.name);
    });

    return {
        deviceName: deviceName,
        devices: devices,
        showExtendedInfos: AppState.user.get('is_expert'),
        valueGroups: allValueGroups,
        selectedDevice: selectedDevice,
        selectedValues: Misc.selectWhere(allValues, function (v) {
            return selectedValues.includes(v.uniqueId);
        }),
    };
}

function getRequiredDevicesInDialog(deviceValues, selectedValues, selectedDevice) {
    // list all devices where the config is required
    var allDevices = getConfigDialogSelectedDevices(selectedValues);
    if (selectedDevice != 0 && !allDevices.includes(selectedDevice)) {
        allDevices.push(selectedDevice);
    }
    allDevices = Misc.selectWhere(allDevices, function (d) {
        return (
            Misc.selectWhere(deviceValues, function (f) {
                return f.id == d;
            }).length == 0
        );
    });
    return allDevices;
}

module.exports = OOP.extend(
    Marionette.ItemView,
    {
        template: require('components/devices/templates/gateway/overview_configure_dialog'),
        data: {
            devices: [],
            deviceValues: [],
            selectedValues: [],
            selectedDevice: 0,
        },

        ui: {
            ddlDevices: 'select.js-devices',
            ddlValues: 'select.js-values',
        },

        events: {
            'change select.js-devices': function (e) {
                this.data.selectedDevice = parseInt(this.ui.ddlDevices.val() || 0);
                this.loadDeviceConfig();
                this.render();
            },
            'change select.js-values': function (e) {
                var values = this.ui.ddlValues.val();
                this.data.selectedValues = values || [];
                this.render();
            },
            'click button#js-save': function (e) {
                App.hideModal();
                if (this.options.cb) {
                    this.options.cb(this.data.selectedValues);
                }
            },
        },

        initialize: function (options) {
            this.data.devices = options.devices;
            if (options.devices && options.devices.length > 0) {
                this.data.selectedDevice = options.devices[0].id;
            }
            if (options.selectedValues) {
                this.data.selectedValues = getConfigValueIDs(options.selectedValues || []);
            }
        },

        onShow: function () {
            $('#js-modal-dialog .modal-dialog').addClass('modal-lg');

            this.loadDeviceConfig();
            this.render();
        },

        loadDeviceConfig: function () {
            var self = this;
            var devices = getRequiredDevicesInDialog(
                this.data.deviceValues,
                this.data.selectedValues,
                this.data.selectedDevice
            );
            if (devices.length != 0) {
                $.when(App.request('devices:configurations', devices)).done(function (content) {
                    if (content) {
                        for (var i = 0; i < content.length; i++) {
                            self.data.deviceValues.push(content[i]);
                        }
                        self.render();
                    }
                });
            }
        },

        onDestroy: function () {
            $('#js-modal-dialog .modal-dialog').removeClass('modal-lg');
        },

        close: function () {
            App.hideModal();
        },

        onAttach: function () {
            this.initializeMultiSelect();
        },

        onRender: function () {
            this.initializeMultiSelect();
        },

        initializeMultiSelect: function () {
            Misc.initializeMultiSelect('#value-multi-select', i18n.TR('Verfügbar'), i18n.TR('Ausgewählt'));
            Misc.initSelectPicker();
        },

        serializeData: function () {
            return getConfigDialogData(
                this.data.devices,
                this.data.deviceValues,
                this.data.selectedValues,
                this.data.selectedDevice,
                this.options.deviceName
            );
        },
    },
    'OverviewConfigureDialog'
);
